// Parse a date string from the API (stored in Pacific time, no timezone indicator)
// Appending 'Z' corrects the UTC offset so JS displays the right local time
export function parseApiDate(str) {
  if (!str) return new Date();
  const d = new Date(str);
  return isNaN(d.getTime()) ? new Date() : d;
}